import { render, staticRenderFns } from "./DailyProblemListings.vue?vue&type=template&id=bbc12512&scoped=true&"
import script from "./DailyProblemListings.vue?vue&type=script&lang=ts&"
export * from "./DailyProblemListings.vue?vue&type=script&lang=ts&"
import style0 from "./DailyProblemListings.vue?vue&type=style&index=0&id=bbc12512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc12512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bbc12512', component.options)
    } else {
      api.reload('bbc12512', component.options)
    }
    module.hot.accept("./DailyProblemListings.vue?vue&type=template&id=bbc12512&scoped=true&", function () {
      api.rerender('bbc12512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/DailyProblemListings.vue"
export default component.exports